import * as React from "react";
import pageIds from "~/pageIds";
import type { CategorizedPageHelpRegistration, RenderRegistrationCardProps } from "../../../Registry/pageHelpRegistry";
import { CommonProjectVariableOverview } from "../../CommonComponents/CommonProjectVariableViews";
export const ProjectVariableTemplatesRegistration: CategorizedPageHelpRegistration = {
    page: pageIds.project().variables.projectTemplates,
    renderOverview: (renderProps: RenderRegistrationCardProps) => {
        return <CommonProjectVariableOverview />;
    },
    renderTopics: (renderProps: RenderRegistrationCardProps) => null,
};
